export default {
  sm: 320,
  md: 768,
  lg: 1000,
  xl: 1680
};
